import { useCallback } from 'react';

import { useMapContext } from './MapContext';

interface MapLayerFilterResult {
  /**
   * @param filter - Filter conforming to Mapbox Style Specification filter definition
   * https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/#filter
   */
  applyFilter: (layerIds: string[], filter: unknown[] | boolean | null) => void;
  removeFilter: (layerIds: string[]) => void;
}

export const useMapLayerFilter = (): MapLayerFilterResult => {
  const { map: mapInstance } = useMapContext();

  const applyFilter = useCallback(
    (layerIds: string[], filter: unknown[] | boolean | null) => {
      if (!mapInstance?.getStyle()) {
        return;
      }
      layerIds.forEach((layerId) => mapInstance.setFilter(layerId, filter));
    },
    [mapInstance]
  );

  const removeFilter = useCallback(
    (layerIds: string[]) => {
      applyFilter(layerIds, null);
    },
    [applyFilter]
  );

  return { applyFilter, removeFilter };
};
